import MuiLink from '@mui/material/Link';
import Skeleton from '@mui/material/Skeleton';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { StatusBadge } from '../../../../../components/atoms/StatusBadge';
import { useGetOneShipment } from '../../../../../queries/shipment-query';

const cellSx = { fontSize: '12px', py: 0.75, px: 1.5 };

const formatDate = (dateStr: string | undefined): string => {
  if (!dateStr) return '-';
  const parsed = new Date(dateStr);
  if (Number.isNaN(parsed.getTime())) return '-';
  return parsed.toLocaleDateString(undefined, { dateStyle: 'medium' });
};

export interface LinkedShipmentRowProps {
  shipmentId: number;
  zebra: boolean;
}

export const LinkedShipmentRow: React.FC<LinkedShipmentRowProps> = ({ shipmentId, zebra }) => {
  const { data: shipment, isLoading, isError } = useGetOneShipment(shipmentId);
  const statusName = shipment?.shipmentStatusName ?? '';
  const typeName = shipment?.shipmentTypeName ?? shipment?.shipmentTypeCode ?? '';
  const route =
    shipment?.source && shipment?.destination
      ? `${shipment.source} → ${shipment.destination}`
      : (shipment?.destination ?? shipment?.source ?? '');
  const updatedAt = shipment?.updatedAt ?? shipment?.createdAt;

  return (
    <TableRow
      sx={{
        bgcolor: zebra ? 'v4.tableEven' : 'transparent',
        '&:hover': { bgcolor: 'v4.tableHover' },
      }}
    >
      <TableCell sx={cellSx}>
        <MuiLink
          component={RouterLink}
          to={`/shipments/${shipmentId}`}
          sx={{ fontSize: '12px', fontWeight: 500, color: 'v4.accent' }}
          underline="hover"
        >
          {`SHIP-${shipmentId}`}
        </MuiLink>
      </TableCell>
      <TableCell sx={cellSx}>
        {isLoading ? (
          <Skeleton variant="rounded" width={70} height={18} />
        ) : isError || !statusName ? (
          '—'
        ) : (
          <StatusBadge status={statusName} size="small" />
        )}
      </TableCell>
      <TableCell sx={cellSx}>
        {isLoading ? <Skeleton variant="text" width={80} /> : typeName || '—'}
      </TableCell>
      <TableCell sx={cellSx}>
        {isLoading ? <Skeleton variant="text" width={140} /> : route || '—'}
      </TableCell>
      <TableCell sx={cellSx}>
        {isLoading ? <Skeleton variant="text" width={70} /> : formatDate(updatedAt)}
      </TableCell>
    </TableRow>
  );
};
